const Credits = () => {
  return (
    <div className='credits'>
      Archive Explorer v2.01, <a href="https://github.com/ateryaev/archive-explorer">github.com</a><br />
      Developed by Anton Teryaev, 2023<br />
    </div>
  );
};

export default Credits;
